import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const SendCleanLaundry = lazy(() => import('./send-clean-laundry.component'));

export function useSendCleanLaundryRoutes() {
    return (
        <Route path='send_clean_laundry'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <SendCleanLaundry />
                    </AsyncComponent>
                }
            />
        </Route>
    );
}
